"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeOrganizationUser = void 0;
const sample_data_1 = require("@home-health-notify/sample-data");
const mappers_1 = require("../mappers");
const models_1 = require("../models");
const roleAccess_1 = require("../roleAccess/roleAccess");
const FakeNetworkManager_1 = require("./FakeNetworkManager");
const IAbortableResult_1 = require("../utils/IAbortableResult");
/* eslint-disable @typescript-eslint/no-unused-vars */
class FakeOrganizationUser {
    constructor(orgUserType, hhnStorage) {
        this.slowMessageSendListeners = [];
        this.alert = null;
        this.assetManager = null;
        this.exportChat = null;
        this.userDirectory = null;
        this.orgUserType = orgUserType || sample_data_1.ORG_USER_TYPE.ADMIN;
        this.starredMessage = null;
        this.chatManager = null;
        this.networkManager = new FakeNetworkManager_1.FakeNetworkManager();
        this.labsManager = null;
        this.emrManager = null;
        this.allLabRequisitionsManager =
            null;
        this.syncQueueManager = null;
        if (hhnStorage)
            this.hhnStorage = hhnStorage;
    }
    isLabIntegrationEnabled() {
        throw new Error("Method not implemented.");
    }
    isEmrSyncEnabled() {
        throw new Error("Method not implemented.");
    }
    getEmrSyncMode() {
        throw new Error("Method not implemented.");
    }
    getEmrSyncInternalGroupIds() {
        throw new Error("Method not implemented.");
    }
    updateEmrSettings() {
        throw new Error("Method not implemented.");
    }
    isAutoAckEnabled() {
        throw new Error("Method not implemented.");
    }
    fetchAutoAckEvents() {
        throw new Error("Method not implemented.");
    }
    fetchAutoAckRules() {
        throw new Error("Method not implemented.");
    }
    saveAutoAckRules() {
        throw new Error("Method not implemented.");
    }
    fetchGeneralSettings() {
        throw new Error("Method not implemented.");
    }
    saveGeneralSettings() {
        throw new Error("Method not implemented.");
    }
    getTemplateByKey(templateKey, chatInfo, templateFilledBy) {
        throw new Error("Method not implemented.");
    }
    deleteQuickReplies(index) {
        throw new Error("Method not implemented.");
    }
    addQuickReplies(quickReply) {
        throw new Error("Method not implemented.");
    }
    switchOrganization() {
        throw new Error("Method not implemented.");
    }
    getSocketManager() {
        throw new Error("Method not implemented.");
    }
    getExportChatData() {
        throw new Error("Method not implemented.");
    }
    updateNotificationSettings(notificationSettings) {
        throw new Error("Method not implemented.");
    }
    registerChangeListener(cb) {
        throw new Error("Method not implemented.");
    }
    updateDoNotDisturb(dnd) {
        throw new Error("Method not implemented.");
    }
    getNotificationManager() {
        throw new Error("Method not implemented.");
    }
    onDND() {
        throw new Error("Method not implemented.");
    }
    groupNotificationSetting(groupType) {
        throw new Error("Method not implemented.");
    }
    sameUser(userId) {
        throw new Error("Method not implemented.");
    }
    isExternalUser() {
        throw new Error("Method not implemented.");
    }
    disconnectSockets() {
        throw new Error("Method not implemented.");
    }
    getLastSyncTime() {
        throw new Error("Method not implemented.");
    }
    isActive() {
        throw new Error("Method not implemented.");
    }
    isOrganization(orgId) {
        return this.getOrganization().organizationId === orgId;
    }
    isSameOrganization(orgData) {
        return this.getOrganization().organizationId === orgData.organizationId;
    }
    getOrgUniqueIdentifer() {
        return this.getOrganization().organizationId;
    }
    getOrganizationId() {
        return this.getOrganization().organizationId;
    }
    open() {
        throw new Error("Method not implemented.");
    }
    initOrganization(isLoadChatList) {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    addCommunityLiaisoning(name) {
        return Promise.resolve(false);
    }
    addReferralSource(name) {
        return Promise.resolve(false);
    }
    addSocketResponseErrorListener(cb) {
        throw new Error("Method not implemented");
    }
    addSlowMessageSendListener(cb) {
        this.slowMessageSendListeners.push(cb);
        return () => {
            this.slowMessageSendListeners = this.slowMessageSendListeners.filter(listener => listener !== cb);
        };
    }
    emitSlowMessageSend(data) {
        this.slowMessageSendListeners.forEach(listener => listener(data));
    }
    countersListeners(cb) {
        throw new Error("Method not implemented");
    }
    getCounters() {
        throw new Error("Method not implemented");
    }
    fetchDepartments(organizationId) {
        return Promise.resolve([]);
    }
    getBroadcastChatManager() {
        throw new Error("method not implemented");
    }
    getChatManagerForGroupType(groupType) {
        throw new Error("method not implemented");
    }
    getCommunityLiaisoning(requestParam, context) {
        return Promise.resolve((0, IAbortableResult_1.CompletedResult)([]));
    }
    getDepartments() {
        return [];
    }
    fetchExportChatData(params) {
        throw new Error("method not implemented");
    }
    getHiddenGroupChatManager() {
        throw new Error("method not implemented");
    }
    getNonPatientChatManager() {
        throw new Error("method not implemented");
    }
    getOrganization() {
        const organizationData = (0, mappers_1.organizationMapper)(sample_data_1.orgData.data);
        return organizationData[this.orgUserType];
    }
    getPatientChatManager() {
        throw new Error("method not implemented");
    }
    getPrivateChatManager() {
        throw new Error("method not implemented");
    }
    getReferralSource(requestParam, context) {
        return Promise.resolve((0, IAbortableResult_1.CompletedResult)([]));
    }
    getSignedUrl(url) {
        throw new Error("method not implemented");
    }
    hasAccess(feature) {
        const role = this.getUserTypeFromOrgUserType();
        const roleAccesses = roleAccess_1.roleAccess[role];
        return roleAccesses.includes(feature);
    }
    isOrganizationActive() {
        return false;
    }
    destroy() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    removeCountersListeners() { }
    removeSocketResponseErrorListener() { }
    getUserTypeFromOrgUserType() {
        switch (this.orgUserType) {
            case sample_data_1.ORG_USER_TYPE.OFFICE_STAFF:
                return models_1.USER_TYPE.STAFF;
            case sample_data_1.ORG_USER_TYPE.FIELD_STAFF:
                return models_1.USER_TYPE.USER;
            case sample_data_1.ORG_USER_TYPE.PHYSICIAN:
                return models_1.USER_TYPE.PHYSICIAN;
            case sample_data_1.ORG_USER_TYPE.PATIENT:
                return models_1.USER_TYPE.PATIENT;
            default:
                return models_1.USER_TYPE.ADMIN;
        }
    }
    getStorage() {
        return this.hhnStorage;
    }
    getNetworkManager() {
        return this.networkManager;
    }
    markMessageAsDeliveredListener(cb) {
        throw new Error("method not implemented");
    }
    getRecentContacts(bucket) {
        throw new Error("method not implemented");
    }
    get organizationMedia() {
        throw new Error("method not implemented");
    }
    fetchOrganizationMedia() {
        throw new Error("method not implemented");
    }
    fetchRecentContacts(bucket, filters, context, paginate) {
        return Promise.resolve(undefined);
    }
    resetRecentContactsData(bucket) { }
    forwardMessage(selectedContacts, selectedMessages) {
        throw new Error("method not implemented");
    }
    sendMediaToContacts(selectedContacts, uploadedMediaList) {
        throw new Error("method not implemented");
    }
    get templates() {
        throw new Error("method not implemented");
    }
    fetchAllTemplates() {
        return Promise.resolve(undefined);
    }
    getScheduledVisits(params) {
        return Promise.resolve([]);
    }
    updateUserProfile(userProfileData) {
        throw new Error("method not implemented");
    }
    fetchQuickReplies() {
        throw new Error("method not implemented");
    }
    get quickReplies() {
        return [];
    }
}
exports.FakeOrganizationUser = FakeOrganizationUser;
